import React, { ComponentProps, FC, useMemo } from 'react';

import { Link } from 'react-router-dom';

import { getAccHostname } from '@adsk/acs-sc-web-platform-api';
import { TOOL_IDS } from '@adsk/alloy-provider';
import { SideNavigationItem } from '@adsk/alloy-side-navigation';

import TemplateConfigurationItemFooter from './TemplateConfigurationItemFooter';
import { useCurrentRoute } from '../../hooks/useCurrentRoute';
import safeGetPathname from '../../utils/safeGetPathname';
import { checkExcludedPath } from '../ExoSkeletonApi/ExoSkeletonApi';

type LocalSideNavigationItemProps = ComponentProps<
  typeof SideNavigationItem
> & {
  isTemplate?: boolean;
};

const LocalSideNavigationItem: FC<LocalSideNavigationItemProps> = ({
  isTemplate,
  ...props
}) => {
  const currentRoute = useCurrentRoute();
  const isTemplateConfiguration =
    isTemplate && props.item.key === TOOL_IDS.CONFIGURATION;

  const to = useMemo(() => {
    if (!props?.item?.url) {
      return undefined;
    }

    const pathname = safeGetPathname(props.item.url);

    if (!pathname) {
      return undefined;
    }

    const shouldAddHostname = checkExcludedPath(pathname, currentRoute);

    return shouldAddHostname
      ? new URL(pathname, getAccHostname()).href
      : pathname;
  }, [props?.item?.url, currentRoute]);

  if (!to) {
    return null;
  }

  return (
    <>
      <SideNavigationItem
        {...props}
        as={Link}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore this prop is passed to Link component
        to={to}
        style={isTemplateConfiguration ? { margin: '12px 0' } : undefined}
      />
      {isTemplateConfiguration && (
        <TemplateConfigurationItemFooter collapsed={props.collapsed} />
      )}
    </>
  );
};

LocalSideNavigationItem.propTypes = {
  ...SideNavigationItem.propTypes,
};

export default LocalSideNavigationItem;
